import { MatSpinner } from '@angular/material/progress-spinner';
import { ChangeDetectionStrategy, Component, inject, model, signal, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Collaboration, Collaborateur, Distribution, ListItem, ModalListItemI, Site, Stock, User } from '../../../shared/model';
import { SiteService } from '../../service/site-service';
import { TitleComponent } from "../../../shared/components/title-component/title-component";
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { SearchBarComponent } from '../../../shared/components/search-bar-component/search-bar-component';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatCardModule, MatCardTitle } from '@angular/material/card';
import { NgIf, UpperCasePipe } from '@angular/common';
import { ToastrService } from '../../../shared/services/toastr-service';
import { UserService } from '../../../utilisateur/service/user-service';
import { SweetAlertService } from '../../../shared/services/sweet-alert-service';
import { UserComponentModal } from '../../../utilisateur/component/user-component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormBuilder, FormGroup, FormsModule, NgModel, ReactiveFormsModule, Validators, ɵInternalFormsSharedModule } from '@angular/forms';
import { StockService } from '../../../distribution/service/stock-service';
import { ListModalComponent } from '../../../shared/components/list-modal-component/list-modal-component';
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatSelect } from '@angular/material/select';
import { MatListModule } from "@angular/material/list";
import { RangePipe } from '../../../shared/pipes/range-pipe';
import { RangeStartValuePipe } from '../../../shared/pipes/range-start-value-pipe-pipe';
import { DatabaseConnection } from '../../../shared/services/database-connection';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { AuthService } from '../../../auth/services/auth-service';

export interface ModalUserDataI{
  title : string
  update ?: boolean
  data ?: User
  site_id ?: string
}


@Component({
  selector: 'app-site-detail-component',
  imports: [
    TitleComponent,
    MatTabsModule,
    MatCardModule,
    SearchBarComponent,
    MatIconModule,
    MatPaginator,
    MatPaginatorModule,
    MatSort,
    MatSortModule,
    MatTableModule,
    MatSpinner,
    UpperCasePipe,
    MatTooltip,
    MatButton,
    MatSlideToggle,
    ɵInternalFormsSharedModule,
    NgIf
],
  templateUrl: './site-detail-component.html',
  styleUrl: './site-detail-component.css',
})
export class SiteDetailComponent {

  site_id : string = ""
  currentSite = signal<Site>(new Site())
  searchValue = ""
  loading = false

  displayedColumns: string[] = ["id", "collaborateur_name", "name", "owner", "adresse", "status", "actions"];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  @ViewChild(MatPaginator) paginator!: MatPaginator;



  currentTabName : string = ''
  readonly dialog = inject(MatDialog)
  currentUser = signal<User>(new User())

  API_STORAGE = inject(DatabaseConnection).storageConnection.value

  authUser = inject(AuthService)

  showTabs = signal({
    collab : true,
    doc : false,
    user : false
  })

  constructor(
     private route : ActivatedRoute,
     private siteService : SiteService,
     private toastr : ToastrService,
     private userService : UserService,
     private sweetAlert : SweetAlertService
  ){

  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.route.params.subscribe((data) => {
      this.site_id = data['id']
      this.siteService.get(this.site_id).subscribe(res => this.currentSite.update(site => res))
    })

    if(this.authUser.getCurrentUser().user.profil['site_collabs'])
      this.loadTabView('Collaborateurs')
    else if(this.authUser.getCurrentUser().user.profil['stock_sites'])
      this.loadTabView('Documents')
    else
      this.loadTabView('Utilisateurs')

  }

  ngAfterViewInit(): void {


  }

  setColorQteState(qte : number, reste : number){
    const tiers = qte/3
    const deuxTiers = (qte*2)/3

    if(reste<=tiers){
      return "state_inactif";
    }else if(reste<=deuxTiers){
      return "state_orange"
    }else{
      return "state_actif"
    }
  }

  applyFilter(val : string){
    this.searchValue = val
    this.dataSource.filter = val.trim().toLocaleLowerCase()

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  loadTabView(currentTabName : string){
    this.dataSource.filter = ""


    switch (currentTabName) {
      case 'Collaborateurs':
        const collab = {user : false, collab: true, doc : false}
        this.showTabs.update(val => collab)
        this.collabView()
        break
      case 'Utilisateurs':
        const user = {user : true, collab : false, doc : false}
        this.showTabs.update(val => user)
        this.userView()
        break

      default:
        break;
    }
  }

  userView(){
      this.dataSource = new MatTableDataSource();
      this.displayedColumns = ['id', 'name', 'profil', 'gender', 'adresse', 'status', 'actions']
      this.loading = true
      this.dataSource.paginator = this.paginator;
      this.siteService.getSiteUsers(this.site_id).subscribe(
        (res) => {
          this.dataSource.data = res;
          this.loading = false
        },
        (err) => this.loading = false
      )
  }

  collabView(){
    this.dataSource = new MatTableDataSource();
      this.displayedColumns = ['id', 'collaborateur', 'logo', 'owner', 'adresse', 'actions']
      this.dataSource.paginator = this.paginator;
      this.loading = true
      this.siteService.getSiteCollaborateurs(this.site_id).subscribe(
        (res) => {
          this.dataSource.data = res;
          this.loading = false
        },
        (err) => this.loading = false
      )
  }

  onTabChange(event : MatTabChangeEvent){
    //console.log(event.index, ' ', event.tab.textLabel);
    this.currentTabName = event.tab.textLabel
    this.loadTabView(event.tab.textLabel)
  }

  attestationFormat(rangeValue : string, code : string, type : string){
    const range = rangeValue.split('-')
    return 'de '+code+'*'+type+'*'+range[0].toString().padStart(7, '0')+' à '+code+'*'+type+'*'+range[1].toString().padStart(7, '0')
  }

  openAddUserModal(){
    const data : ModalUserDataI = {
      title : 'Ajouter un utilisateur',
      data : new User(),
      site_id : this.site_id
    }

    const dialogRef = this.dialog.open(UserComponentModal, {
      width : '700px',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data
    });

    dialogRef.afterClosed().subscribe((result : User) => {

      if (result?.id != undefined) {
        const data : User[] = []
        data.push(...this.dataSource.data)
        data.push(result)

        this.dataSource.data = data
        this.toastr.success("L'utilisateur "+ result.name + " à été ajouté")
      }
    });
  }

  openUpdateUserModal(user : User){
    this.currentUser.set(user)

    const data : ModalUserDataI = {
      title : "Modifier l'utilisateur " + user.name,
      update : true,
      data : this.currentUser()
    }

    const dialogRef = this.dialog.open(UserComponentModal, {
      width : '700px',
      height: 'fit-content',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data
    });

    dialogRef.afterClosed().subscribe((result : User) => {

      if (result?.id != undefined) {
        const i = this.dataSource.data.findIndex(item => item.id == result.id)
        const data = this.dataSource.data
        data[i] = result
        this.dataSource.data = data
        this.toastr.success("L'utilisateur "+ result.name + " à été modifie")
      }
    });
  }

  confirm(user : User){
    this.sweetAlert
    .confirm("Etez-vous sur de vouloir supprimer l'utilisateur "+ user.name)
    .then((res) =>{
      if(res.isConfirmed){
        this.userService.delete(user.id).subscribe({
          next : (r) =>{
            this.dataSource.data = this.dataSource.data.filter(item => item.id != user.id)
            this.sweetAlert.success('Suppression reussie', 2000)
          }
        })
      }
    })
  }

  onChange(user : User){
    const title = user.disable?'Activation':'Desactivation'
    const action = user.disable?'activer':'desactiver'
    this.sweetAlert.confirm("Etez-vous sur de vouloir "+ action +" l' utilisateur " + user.name)
    .then((res) =>{
      if(res.isConfirmed){
        this.userService.changeUserStatus(user.id).subscribe({
          next : (result) =>{

            const i = this.dataSource.data.findIndex(item => item.id == result.id)
            const data = this.dataSource.data
            data[i] = result
            this.dataSource.data = data

            this.sweetAlert.success('Operaton reussie', 2000)
          }
        })
      }
    })
  }


  changeCollabState(collab : Collaboration){
    this.siteService.changeCollabState(collab.id).subscribe({
      next : (res) =>{
        const data = this.dataSource.data as Collaboration[]
        const index = data.findIndex(item => item.id == res.id)
        data[index].active = res.active
        this.dataSource.data = data
      },
      error : (err) =>{
        this.toastr.error("Une erreur est survenue")
      }
    })
  }

}

